import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { XIcon } from "lucide-react";
import { SwitchCheckIcon, LoadingIcon } from "@/components/Icons";

import { cn } from "@/lib/utils";

function Switch({
  className,
  isLoading = false,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  isLoading?: boolean;
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "peer group data-[state=unchecked]:bg-input inline-flex h-[1.15rem] w-8 shrink-0 cursor-pointer items-center rounded-full border border-transparent shadow-xs transition-all outline-none disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-blue-600 dark:data-[state=unchecked]:bg-zinc-200",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none inline-flex size-4 items-center justify-center rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"
        )}
      >
        <LoadingIcon
          className={cn(
            isLoading ? "text-primary inline-flex h-2.5 w-2.5" : "hidden"
          )}
        />
        <XIcon
          className={cn(
            isLoading
              ? "hidden"
              : "inline-flex h-2.5 w-2.5 text-black group-data-[state=checked]:hidden"
          )}
        />
        <SwitchCheckIcon
          className={cn(
            isLoading
              ? "hidden"
              : "hidden h-2.5 w-2.5 text-black group-data-[state=checked]:inline-flex"
          )}
        />
      </SwitchPrimitive.Thumb>
    </SwitchPrimitive.Root>
  );
}

export { Switch };
